import { PlusOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

interface InsertControlsProps {
    onAddFilter: () => void;
    onAddGroup: () => void;
    position: "between" | "end";
}

export const InsertControls = ({ onAddFilter, onAddGroup, position }: InsertControlsProps) => {
    const buttonSize = position === "between" ? "small" : "middle";
    const className =
        position === "between"
            ? "flex justify-center my-2 opacity-50 hover:opacity-100 transition-opacity"
            : "flex justify-center mt-4";
    const { t } = usePaldockTranslation("ui.offer-filter");

    return (
        <div className={className}>
            <Space>
                <Button size={buttonSize} type="dashed" icon={<PlusOutlined />} onClick={onAddFilter}>
                    {t("actions.add_filter")}
                </Button>
                <Button size={buttonSize} type="dashed" icon={<PlusOutlined />} onClick={onAddGroup}>
                    {t("actions.add_group")}
                </Button>
            </Space>
        </div>
    );
};
